import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { StoreService } from './../../store.service'; 

@Component({
  selector: 'app-skill-form',
  templateUrl: './skill-form.component.html',
  styleUrls: ['./skill-form.component.css']
})
export class SkillFormComponent implements OnInit {

  @Input() skill: any
  @Input() type: any

  constructor( private fb : FormBuilder, private $store : StoreService) { }
    
  loading: boolean 
  show = false
  selectedCategory = 'Famille'
  selectedDomain = 'Domaine'
  selectedLevel = 'Niveau de maîtrise'
  checked = false
  customClass = 'noShow'
  customClassForm = ''
  categories : any
  category : any

  form_expertise = new FormGroup({
    categ: new FormControl('', Validators.required),
    domain: new FormControl('', Validators.required),
    level: new FormControl('', Validators.required), 
    certified: new FormControl(false), 
  })

  ngOnInit() {

    this.form_expertise.controls.categ.clearValidators
    this.categories = this.$store.getSkillCategories(this.type)
    this.categories.length === 1 ? 
      (this.category = this.categories[0].skills, 
        this.form_expertise.removeControl('categ')) : ''
      
    

    if (this.skill) {
      this.selectedDomain = this.skill.skillName
      this.selectedCategory = this.skill.category
      var foo = this.selectedLevel = this.$store.levels.find(
        l => l.id === this.skill.level
      )
      this.skill.type === 'langage' ? this.selectedLevel = foo.descr_lang : 
       this.selectedLevel = foo.descr

      this.checked = this.skill.certified
    }

    this.customClass = 'noShow'
    this.customClassForm = ''

    
  }

  addSkill(form, type){
    console.log('FORM', this.form_expertise)
    this.loading = true
    this.$store.addSkill(form, type)
      .catch(err => console.log('There was error', err))
      .then(() => this.loading = false)
      .then(() => {this.show = false,
        this.form_expertise = new FormGroup({
          categ: new FormControl('', Validators.required),
          domain: new FormControl('', Validators.required),
          level: new FormControl('', Validators.required), 
          certified: new FormControl(false), 
        }), 
        this.categories.length === 1 ? 
        (this.category = this.categories[0].skills, 
          this.form_expertise.removeControl('categ')) : ''})
  }

  updateSkill(form){
    this.loading = true
    this.$store.updateSkill(form, this.skill.id) 
      .catch(err => console.log('There was error', err))
      .then(() => this.loading = false)
      .then(() => this.show = false)
  }

  getSkills(type, category) {
    console.log(this.$store.skills)
    var t = this.$store.skills.find(skill => {return skill.type === type})
    console.log(t)
    if (t.categories) {
      let u = t.categories.find( s => {return s.category === category})    
      console.log(u )
      this.category = u.skills
    }
 
  }

  checkSkill($skillId) {
    if (this.$store.profile.skills.find(skill => skill.skillId === $skillId))
    return true
    else return false
  }

  switchShow() {
    if (this.show) {
      this.customClass = 'noShow'
      setTimeout(this.show = !this.show, 1000)
    }
    else { 
      this.show = !this.show
      this.customClass = 'showBack'
      this.customClassForm = 'form-control md-col-8 popup_cont' }
  }

   

}


// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/skill-form/skill-form.component.ts